import React from "react";
import SignUpSuccess from "../../organisms/InitialPagesComponents/SignUpSuccess/SignUpSuccess";

const SignUpSuccessPage = () => {
  return <SignUpSuccess />;
};

export default SignUpSuccessPage;
